import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _parseInt from '@babel/runtime-corejs3/core-js-stable/parse-int';
import _Number$isNaN from '@babel/runtime-corejs3/core-js-stable/number/is-nan';
import _parseFloat from '@babel/runtime-corejs3/core-js-stable/parse-float';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context11, _context12; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context11 = ownKeys(Object(t), !0)).call(_context11, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context12 = ownKeys(Object(t))).call(_context12, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign,no-nested-ternary,no-bitwise,no-multi-assign,prefer-destructuring */

var STRING_PARSERS = [{
  re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
  format: 'hex',
  parse: function parse(execResult) {
    return [_parseInt(execResult[1], 16), _parseInt(execResult[2], 16), _parseInt(execResult[3], 16), 1];
  }
}, {
  re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
  format: 'hex',
  parse: function parse(execResult) {
    return [_parseInt(execResult[1] + execResult[1], 16), _parseInt(execResult[2] + execResult[2], 16), _parseInt(execResult[3] + execResult[3], 16), 1];
  }
}, {
  re: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*?\)/,
  format: 'rgb',
  parse: function parse(execResult) {
    return [execResult[1], execResult[2], execResult[3], 1];
  }
}, {
  re: /rgb\(\s*(\d+(?:\.\d+)?)%\s*,\s*(\d+(?:\.\d+)?)%\s*,\s*(\d+(?:\.\d+)?)%\s*?\)/,
  format: 'rgb',
  parse: function parse(execResult) {
    return [Math.round(2.55 * execResult[1]), Math.round(2.55 * execResult[2]), Math.round(2.55 * execResult[3]), 1];
  }
}, {
  re: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
  format: 'rgba',
  parse: function parse(execResult) {
    return [execResult[1], execResult[2], execResult[3], execResult[4]];
  }
}, {
  re: /rgba\(\s*(\d+(?:\.\d+)?)%\s*,\s*(\d+(?:\.\d+)?)%\s*,\s*(\d+(?:\.\d+)?)%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
  format: 'rgba',
  parse: function parse(execResult) {
    return [Math.round(2.55 * execResult[1]), Math.round(2.55 * execResult[2]), Math.round(2.55 * execResult[3]), execResult[4]];
  }
}, {
  re: /hsl\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)%\s*,\s*(\d+(?:\.\d+)?)%\s*?\)/,
  format: 'hsl',
  parse: function parse(execResult) {
    return [_parseInt(execResult[1], 10), execResult[2] / 100, execResult[3] / 100, 1];
  }
}, {
  re: /hsla\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)%\s*,\s*(\d+(?:\.\d+)?)%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
  format: 'hsla',
  parse: function parse(execResult) {
    return [_parseInt(execResult[1], 10), execResult[2] / 100, execResult[3] / 100, _parseInt(execResult[4], 10)];
  }
}];
var Color = /*#__PURE__*/function () {
  function Color(val) {
    _classCallCheck(this, Color);
    this.value = {
      h: 0,
      s: 0,
      b: 0,
      a: 1
    };
    if (typeof val === 'string') {
      this.setColor(val);
    } else if (typeof val.r === 'number') {
      this.value = this.RGBtoHSB(val.r, val.g, val.b, val.a);
      this.originalFormat = 'rgba';
    } else if (typeof val.h === 'number') {
      if (typeof val.l === 'number') {
        this.value = this.RGBtoHSB.apply(this, _toConsumableArray(this.HSLtoRGB(val.h, val.s, val.l, val.a)));
        this.value.h = val.h;
        this.originalFormat = 'hsla';
      } else {
        this.value = _objectSpread({}, val);
        this.originalFormat = 'hsba';
      }
    }
  }
  _createClass(Color, [{
    key: "$sanitizeNumber",
    value: function $sanitizeNumber(val) {
      if (typeof val === 'number') {
        return val;
      }
      if (_Number$isNaN(val) || val === null || val === '' || val === undefined) {
        return 1;
      }
      if (val.toLowerCase !== undefined) {
        return _parseFloat(val);
      }
      return 1;
    }
  }, {
    key: "setColor",
    value: function setColor(strVal) {
      strVal = strVal.toLowerCase();
      if (strVal.charAt(0) !== '#') {
        strVal = "#".concat(strVal);
      }
      this.value = this.stringToHSB(strVal) || {
        h: 0,
        s: 0,
        b: 0,
        a: 1
      };
    }
  }, {
    key: "stringToHSB",
    value: function stringToHSB(strVal) {
      var _this = this;
      strVal = strVal.toLowerCase();
      var result;
      _someInstanceProperty(STRING_PARSERS).call(STRING_PARSERS, function (parser) {
        var match = parser.re.exec(strVal);
        var values = match && parser.parse(match);
        var format = parser.format || 'rgba';
        if (values) {
          if (format.match(/hsla?/)) {
            var oldHue = values[0];
            result = _this.RGBtoHSB.apply(_this, _toConsumableArray(_this.HSLtoRGB.apply(_this, _toConsumableArray(values))));
            result.h = oldHue;
          } else {
            result = _this.RGBtoHSB.apply(_this, _toConsumableArray(values));
          }
          _this.originalFormat = format;
          return true;
        }
        return false;
      });
      return result;
    }
  }, {
    key: "toRGB",
    value: function toRGB(h, s, b, a) {
      if (!h) {
        h = this.value.h;
        s = this.value.s;
        b = this.value.b;
      }
      var R;
      var G;
      var B;
      h = h % 360 / 60;
      var C = Number(b) * Number(s);
      var X = C * (1 - Math.abs(h % 2 - 1));
      R = G = B = Number(b) - C;
      h = ~~h;
      R += [C, X, 0, 0, X, C][h];
      G += [X, C, C, X, 0, 0][h];
      B += [0, 0, X, C, C, X][h];
      return {
        r: Math.round(R * 255),
        g: Math.round(G * 255),
        b: Math.round(B * 255),
        a: a || this.value.a
      };
    }
  }, {
    key: "toHex",
    value: function toHex(h, s, b, a) {
      var rgb = this.toRGB(Number(h), Number(s), Number(b), Number(a));
      return "#".concat((1 << 24 | _parseInt(String(rgb.r), 10) << 16 | _parseInt(String(rgb.g), 10) << 8 | _parseInt(String(rgb.b), 10)).toString(16).substr(1));
    }
  }, {
    key: "toHSL",
    value: function toHSL(h, s, b, a) {
      h = h || this.value.h;
      s = s || this.value.s;
      b = b || this.value.b;
      a = a || this.value.a;
      var H = h;
      var L = (2 - s) * b;
      var S = s * b;
      if (L > 0 && L <= 1) {
        S /= L;
      } else {
        S /= 2 - L;
      }
      L /= 2;
      if (S > 1) {
        S = 1;
      }
      return {
        h: _Number$isNaN(H) ? 0 : H,
        s: _Number$isNaN(S) ? 0 : S,
        l: _Number$isNaN(L) ? 0 : L,
        a: _Number$isNaN(a) ? 0 : a
      };
    }
  }, {
    key: "toHSB",
    value: function toHSB() {
      return {
        h: this.value.h,
        s: this.value.s,
        b: this.value.b,
        a: this.value.a
      };
    }
  }, {
    key: "RGBtoHSB",
    value: function RGBtoHSB(r, g, b, a) {
      r /= 255;
      g /= 255;
      b /= 255;
      var V = Math.max(r, g, b);
      var C = V - Math.min(r, g, b);
      var H = C === 0 ? null : V === r ? (g - b) / C : V === g ? (b - r) / C + 2 : (r - g) / C + 4;
      H = (Number(H) + 360) % 6 * 60;
      var S = C === 0 ? 0 : C / V;
      return {
        h: this.$sanitizeNumber(H),
        s: S,
        b: V,
        a: this.$sanitizeNumber(a)
      };
    }
  }, {
    key: "HueToRGB",
    value: function HueToRGB(p, q, h) {
      if (h < 0) {
        h += 1;
      } else if (h > 1) {
        h -= 1;
      }
      if (h * 6 < 1) {
        return p + (q - p) * h * 6;
      }
      if (h * 2 < 1) {
        return q;
      }
      if (h * 3 < 2) {
        return p + (q - p) * (2 / 3 - h) * 6;
      }
      return p;
    }
  }, {
    key: "HSLtoRGB",
    value: function HSLtoRGB(h, s, l, a) {
      h /= 360;
      if (s < 0) {
        s = 0;
      }
      var q;
      if (l <= 0.5) {
        q = l * (1 + s);
      } else {
        q = l + s - l * s;
      }
      var p = 2 * l - q;
      var tr = h + 1 / 3;
      var tg = h;
      var tb = h - 1 / 3;
      var r = Math.round(this.HueToRGB(p, q, tr) * 255);
      var g = Math.round(this.HueToRGB(p, q, tg) * 255);
      var b = Math.round(this.HueToRGB(p, q, tb) * 255);
      return [r, g, b, this.$sanitizeNumber(a)];
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return {
        hex: this.toHex(),
        hsb: this.toHSB(),
        hsl: this.toHSL(),
        hslString: this.toString('hsl'),
        hslaString: this.toString('hsla'),
        rgb: this.toRGB(),
        rgbString: this.toString('rgb'),
        rgbaString: this.toString('rgba')
      };
    }
  }, {
    key: "toString",
    value: function toString(format) {
      var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10;
      format = format || this.originalFormat || 'rgba';
      var rgb;
      var hsl;
      switch (format) {
        case 'rgb':
          rgb = this.toRGB();
          return _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "rgb(".concat(rgb.r, ",")).call(_context2, rgb.g, ",")).call(_context, rgb.b, ")");
        case 'rgba':
          rgb = this.toRGB();
          return _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "rgba(".concat(rgb.r, ",")).call(_context5, rgb.g, ",")).call(_context4, rgb.b, ",")).call(_context3, rgb.a, ")");
        case 'hsl':
          hsl = this.toHSL();
          return _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = "hsl(".concat(Math.round(hsl.h), ",")).call(_context7, Math.round(hsl.s * 100), "%,")).call(_context6, Math.round(hsl.l * 100), "%)");
        case 'hsla':
          hsl = this.toHSL();
          return _concatInstanceProperty(_context8 = _concatInstanceProperty(_context9 = _concatInstanceProperty(_context10 = "hsla(".concat(Math.round(hsl.h), ",")).call(_context10, Math.round(hsl.s * 100), "%,")).call(_context9, Math.round(hsl.l * 100), "%,")).call(_context8, hsl.a, ")");
        case 'hex':
          return this.toHex();
        default:
          return '';
      }
    }
  }]);
  return Color;
}();

export { Color as default };
